import script from "./ProblemCancelPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProblemCancelPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ProblemCancelPopup.vue?vue&type=style&index=0&id=0381f896&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0381f896"]])

export default __exports__